export const postData = (state = [], action) => {
  //console.log(action)
  switch (action.type) {
    case 'DATA_LOADED':
      return {
        dataLoaded: true,
        data: action.data,
        sortBy: 'DEFAULT',
        filteredData: action.data,
        type: action.type,
        value: ''
      };

    case 'UPDATE_POST_DATA':
      // sorts name accending
      /*let sorted = action.data.sort(function(a, b) {
         let titleA = a.title.toLowerCase();
         let titleB = b.title.toLowerCase();
         return titleA < titleB ? -1 : titleA > titleB ? 1 : 0;
       });*/
      //console.log(action)
      return {
        dataLoaded: true,
        filteredData: action.filteredData,
        data: state.data,
        sortBy: 'ACCENDING',
        type: action.type,
        value: action.value
      };

    default:
      return {
        filteredData: state.data,
        dataLoaded: false,
        data: state.data,
        type: action.type,
        value: ''
      };
  }
};
